<!-- Sign component HTML - status checks fixed for 'OPEN' vs 'Pending' -->

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner></app-custom-spinner>
</div>
<app-breadcrumb></app-breadcrumb>

<!-- Header -->
<div class="esign-doc-banner d-flex align-items-center gap-3 mb-2 px-3 py-2"
  style="background:linear-gradient(135deg,#f0f4ff,#e8f0fe);border:1px solid #c5d8fc;
         border-radius:6px;font-size:13px;">
  <i class="fa fa-file-text-o" style="font-size:26px;color:#0056b3;"></i>
  <div class="flex-grow-1">
    <span class="fw-bold">{{ envelopeData.envelopeTitle }}</span>
    <span class="ms-2 text-muted" style="font-size:12px;">
      Document #{{ envelopeData.documentId }} &nbsp;|&nbsp; v-{{ envelopeData.version }}
    </span>
  </div>
  <!-- Dynamic status overrides proc-managed status field -->
  <span class="badge"
    [class.bg-success]="isDocumentSigned()"
    [class.bg-primary]="!isDocumentSigned() && envelopeData.currentLayer > 1"
    [class.bg-warning]="!isDocumentSigned() && envelopeData.currentLayer === 1 && (envelopeData.signers?.length > 0)"
    [class.bg-secondary]="!envelopeData.signers?.length"
    [class.bg-danger]="envelopeData.envelopeStatus==='Cancelled'">
    {{
      isDocumentSigned() ? 'Completed' :
      envelopeData.envelopeStatus === 'Cancelled' ? 'Cancelled' :
      envelopeData.currentLayer > 1 ? ('Layer ' + (envelopeData.currentLayer - 1) + ' Signed') :
      envelopeData.signers?.length ? 'Pending Signature' : envelopeData.envelopeStatus
    }}
  </span>
</div>

<!-- My signing status banner -->
<div *ngIf="mySignerRecord"
  style="border:1px solid #dee2e6;border-radius:6px;overflow:hidden;
         background:#fff;margin-bottom:12px;">
  <div class="px-3 py-2 d-flex align-items-center gap-3">
    <div>
      <div style="font-size:12px;font-weight:600;">Your Signing Status</div>
      <div style="font-size:12px;margin-top:2px;">
        Layer {{ mySignerRecord.layerNo }}
        &nbsp;·&nbsp;
        <!-- Use hasAlreadySigned — VW status stays OPEN after signing -->
        <span [class.text-success]="hasAlreadySigned"
              [class.text-danger]="mySignerRecord.status==='Declined'"
              [class.text-warning]="!hasAlreadySigned && isPendingStatus(mySignerRecord.status)"
              class="fw-bold">
          {{ hasAlreadySigned ? 'Signed' : isPendingStatus(mySignerRecord.status) ? 'Pending' : mySignerRecord.status }}
        </span>
      </div>
    </div>

    <!-- FIX: isPendingStatus() replaces === 'Pending' — shows Sign/Decline buttons for OPEN -->
    <!-- FIX: hide buttons if already signed (signedOn populated) -->
    <div class="ms-auto d-flex gap-2" *ngIf="!hasAlreadySigned && isPendingStatus(mySignerRecord.status) && isMyTurn">
      <button mat-stroked-button class="deleteButton" (click)="openDeclineModal()">
        <i class="fa fa-times"></i> Decline
      </button>
      <div class="addIconContiner d-flex gap-2 align-items-center px-3"
        style="cursor:pointer;" (click)="openSignModal()">
        <i class="fa fa-pencil text-white"></i>
        <span class="reload_text text-white">Sign Document</span>
      </div>
    </div>

    <div class="ms-auto d-flex gap-2" *ngIf="!hasAlreadySigned && isPendingStatus(mySignerRecord.status) && !isMyTurn">
      <span style="color:#f39c12;font-size:13px;font-weight:600;padding-top:6px;">
        <i class="fa fa-hourglass-half"></i>
        Waiting for Layer {{ envelopeData.currentLayer }} to finish...
      </span>
    </div>

    <!-- Final document download — always visible when all layers complete -->
    <div *ngIf="isDocumentSigned()"
      style="display:flex;align-items:center;gap:8px;margin-right:12px;">

      <span *ngIf="isFinalizingDoc"
        style="font-size:11px;color:#6c757d;display:flex;align-items:center;gap:6px;">
        <i class="fa fa-spinner fa-spin"></i> Generating signed PDF…
      </span>

      <!-- Download ready -->
    <a *ngIf="finalDocUrl && !isFinalizingDoc" (click)="downloadFinalDoc()" style="cursor:pointer;display:flex;align-items:center;gap:6px;padding:7px 18px;
         background:#0056b3;color:#fff;border-radius:6px;font-size:13px;
         font-weight:700;text-decoration:none;box-shadow:0 2px 6px rgba(0,86,179,0.25);">
  <i class="fa fa-download"></i> Download Signed PDF
</a>
      <!-- Generate (always shown if not finalized yet) -->
      <button *ngIf="!finalDocUrl && !isFinalizingDoc"
        (click)="finalizeDocument()"
        style="display:flex;align-items:center;gap:6px;padding:7px 18px;
               background:#28a745;color:#fff;border:none;border-radius:6px;
               font-size:13px;font-weight:700;cursor:pointer;
               box-shadow:0 2px 6px rgba(40,167,69,0.25);">
        <i class="fa fa-file-pdf-o"></i> Generate &amp; Download
      </button>

      <!-- Retry after error -->
      <button *ngIf="finalizeError && !finalDocUrl && !isFinalizingDoc"
        (click)="finalizeDocument()"
        style="padding:5px 12px;font-size:12px;border:1px solid #dc3545;
               color:#dc3545;background:#fff;border-radius:4px;cursor:pointer;">
        <i class="fa fa-refresh"></i> Retry
      </button>
    </div>

    <div *ngIf="hasAlreadySigned" class="ms-auto">
      <span style="color:#28a745;font-size:13px;">
        <i class="fa fa-check-circle"></i>
        Signed as "<em>{{ mySignerRecord.signedName }}</em>"
        on {{ mySignerRecord.signedOn | date:'dd-MMM-yyyy HH:mm' }}
      </span>
    </div>

    <div *ngIf="mySignerRecord.status==='Declined'" class="ms-auto">
      <span style="color:#dc3545;font-size:13px;">
        <i class="fa fa-times-circle"></i> Declined. Envelope cancelled.
      </span>
    </div>
  </div>
</div>

<!-- Not a signer / no pending action -->
<div *ngIf="!mySignerRecord && envelopeData.envelopeStatus"
  class="alert alert-info mb-3" style="font-size:13px;">
  <i class="fa fa-info-circle"></i>
  You do not have a pending signature action for this envelope,
  or your signing layer has not been reached yet.
</div>

<div class="row g-2">

  <!-- LEFT: PDF.js canvas viewer -->
  <div class="col-md-9">
    <div style="position:relative;border:1px solid #dee2e6;border-radius:6px;
                overflow:hidden;background:#525659;">

      <div *ngIf="isProcessing"
        style="min-height:520px;display:flex;align-items:center;justify-content:center;">
        <div class="text-center text-white">
          <i class="fa fa-spinner fa-spin" style="font-size:40px;"></i>
          <p class="mt-3">Loading document...</p>
        </div>
      </div>

      <div *ngIf="!isProcessing && pdfDoc"
        style="overflow:auto;max-height:70vh;display:flex;justify-content:center;
               align-items:flex-start;padding:10px 0;">
        <div style="position:relative;display:inline-block;flex-shrink:0;">
          <canvas #pdfCanvas class="pdf-base-canvas" style="display:block;"></canvas>
          <canvas #overlayCanvas
            style="position:absolute;top:0;left:0;pointer-events:all;"
            [style.cursor]="getPdfCursor()"
            (click)="onOverlayClick($event)">
          </canvas>
        </div>
      </div>

      <div *ngIf="!isProcessing && !pdfDoc"
        style="min-height:520px;display:flex;align-items:center;
               justify-content:center;color:#ccc;text-align:center;">
        <div>
          <i class="fa fa-file-o" style="font-size:48px;opacity:0.3;"></i>
          <p class="mt-3">Loading document...</p>
        </div>
      </div>
    </div>

    <!-- Page navigation -->
    <div class="d-flex align-items-center justify-content-center gap-3 mt-2"
      *ngIf="totalPages > 1">
      <button class="addIconContiner px-3 py-1" style="cursor:pointer;"
        (click)="prevPage()" [disabled]="currentPage===1">
        <i class="fa fa-chevron-left text-white"></i>
      </button>
      <span style="font-size:12px;color:#495057;">Page {{ currentPage }} of {{ totalPages }}</span>
      <button class="addIconContiner px-3 py-1" style="cursor:pointer;"
        (click)="nextPage()" [disabled]="currentPage===totalPages">
        <i class="fa fa-chevron-right text-white"></i>
      </button>
    </div>

    <!-- Hint when it's my turn -->
    <div *ngIf="isPendingStatus(mySignerRecord?.status) && myField && isMyTurn"
      class="mt-2 text-center"
      style="font-size:12px;color:#0056b3;background:#e8f0fe;border-radius:4px;padding:6px;">
      <i class="fa fa-hand-pointer-o"></i>
      Click any highlighted field on the document, or use <strong>Sign Document</strong>.
      Initials are auto-derived · Date/time auto-stamped · Text fields shown in the modal.
    </div>
  </div>

  <!-- RIGHT: Signing layers status panel -->
  <div class="col-md-3 ps-2">
    <div style="border:1px solid #dee2e6;border-radius:6px;overflow:hidden;background:#fff;">
      <div style="background:#f8f9fa;border-bottom:1px solid #dee2e6;padding:8px 12px;
                  font-size:12px;font-weight:700;color:#495057;">
        <i class="fa fa-users"></i> Signing Status
      </div>
      <div class="px-2 py-2">
        <div *ngFor="let signer of envelopeData.signers; let i=index" class="mb-2">
          <div style="border:1px solid #e9ecef;border-radius:6px;padding:8px 10px;
                      font-size:12px;background:#fff;"
            [style.border-color]="signer.status==='Signed'?'#28a745':
                                  signer.status==='Declined'?'#dc3545':'#dee2e6'">
            <div class="d-flex align-items-center gap-2">
              <span style="width:22px;height:22px;border-radius:50%;background:#0056b3;
                           color:#fff;display:flex;align-items:center;justify-content:center;
                           font-size:11px;font-weight:700;flex-shrink:0;">
                {{ signer.layerNo }}
              </span>
              <div class="flex-grow-1">
                <div style="font-size:11px;font-weight:600;">
                  {{ getUserName(signer.userId) }}
                </div>
                <div style="font-size:10px;color:#888;">Layer {{ signer.layerNo }}</div>
              </div>
              <!-- FIX: OPEN treated as Pending in display -->
              <span style="font-size:11px;"
                [class.text-success]="getSignerStatusLabel(signer) !== 'Pending'"
                [class.text-warning]="getSignerStatusLabel(signer) === 'Pending'"
                [class.text-danger]="signer.status==='Declined'">
                <i class="fa"
                  [class.fa-check-circle]="getSignerStatusLabel(signer) !== 'Pending' && signer.status !== 'Declined'"
                  [class.fa-clock-o]="getSignerStatusLabel(signer) === 'Pending'"
                  [class.fa-times-circle]="signer.status==='Declined'"></i>
                {{ getSignerStatusLabel(signer) }}
              </span>
            </div>
            <!-- Show signed value — date from signedOn, others from signedName -->
            <ng-container *ngIf="signer.signedOn">
              <div *ngIf="getFieldTypeForSigner(signer) === 'date'"
                style="font-size:11px;color:#155724;margin-top:4px;margin-left:28px;">
                {{ signer.signedOn | date:'dd MMM yyyy HH:mm' }}
              </div>
              <div *ngIf="getFieldTypeForSigner(signer) === 'text' && signer.signedName"
                style="font-size:12px;color:#212529;margin-top:4px;margin-left:28px;font-family:Arial;">
                {{ signer.signedName }}
              </div>
              <div *ngIf="getFieldTypeForSigner(signer) !== 'date' && getFieldTypeForSigner(signer) !== 'text' && signer.signedName"
                style="font-size:14px;color:#1a237e;margin-top:4px;margin-left:28px;"
                [style.font-family]="signer.signFont||'Dancing Script'">
                {{ signer.signedName }}
              </div>
              <div *ngIf="signer.comments && getFieldTypeForSigner(signer) === 'signature'" 
                style="font-size:10px;color:#495057;margin-top:6px;margin-left:28px;line-height:1.2;">
                <strong>Reason:</strong> {{ signer.comments }}
              </div>
              <div *ngIf="signer.signatureHash" 
                style="font-size:9px;color:#6c757d;margin-top:2px;margin-left:28px;word-break:break-all;line-height:1.2;">
                <strong>Hash:</strong> <span style="font-family:monospace;">{{ signer.signatureHash }}</span>
              </div>
            </ng-container>
          </div>
          <div *ngIf="i < envelopeData.signers?.length - 1"
            style="text-align:center;padding:2px 0;color:#6c757d;font-size:13px;">
            <i class="fa fa-arrow-down"></i>
          </div>
        </div>

        <div *ngIf="!envelopeData.signers?.length"
          class="text-muted text-center py-2" style="font-size:12px;">
          Loading signers...
        </div>
      </div>
    </div>

    <!-- Action buttons in right panel -->
    <div class="mt-3 d-flex flex-column gap-2"
      *ngIf="!hasAlreadySigned && isPendingStatus(mySignerRecord?.status) && isMyTurn">
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        style="cursor:pointer;" (click)="openSignModal()">
        <i class="fa fa-pencil-square-o text-white"></i>
        <span class="reload_text text-white">Sign Document</span>
      </div>
      <button mat-stroked-button class="deleteButton w-100" (click)="openDeclineModal()">
        <i class="fa fa-times"></i> Decline to Sign
      </button>
    </div>

    <!-- Completed -->
    <div *ngIf="envelopeData.envelopeStatus==='Completed'"
      class="mt-3"
      style="background:#d4edda;border:1px solid #c3e6cb;border-radius:6px;
             padding:10px;font-size:12px;color:#155724;text-align:center;">
      <i class="fa fa-check-circle" style="font-size:20px;"></i>
      <div class="mt-1 fw-bold">Document Fully Signed</div>
      <div style="font-size:11px;margin-top:2px;">
        Completed on {{ envelopeData.completedOn | date:'dd-MMM-yyyy' }}
      </div>
    </div>
  </div>
</div>

<!-- Sign Modal — unified form for all non-date fields -->
<div *ngIf="showSignModal"
  style="position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:1050;"
  (click)="showSignModal=false"></div>

<div *ngIf="showSignModal"
  style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);
         background:#fff;border-radius:8px;box-shadow:0 8px 32px rgba(0,0,0,0.2);
         width:520px;max-width:96vw;max-height:85vh;overflow-y:auto;z-index:1051;">

  <!-- Header -->
  <div style="background:#f8f9fa;border-bottom:1px solid #dee2e6;padding:12px 16px;
              display:flex;align-items:center;justify-content:space-between;
              position:sticky;top:0;z-index:1;">
    <span style="font-size:14px;font-weight:700;color:#495057;">
      <i class="fa fa-pencil-square-o"></i> Sign Document
    </span>
    <i class="fa fa-times" style="cursor:pointer;color:#6c757d;" (click)="showSignModal=false"></i>
  </div>

  <div style="padding:16px;">

    <!-- Dynamic field inputs — one section per non-date field -->
    <div *ngFor="let fi of signFieldInputs; let idx=index"
      [style.margin-bottom]="idx < signFieldInputs.length-1 ? '20px' : '0'"
      [style.padding-bottom]="idx < signFieldInputs.length-1 ? '16px' : '0'"
      [style.border-bottom]="idx < signFieldInputs.length-1 ? '1px solid #dee2e6' : 'none'">

      <!-- Field type badge -->
      <div class="d-flex align-items-center gap-2 mb-2">
        <span style="padding:2px 8px;border-radius:10px;font-size:10px;font-weight:700;"
          [style.background]="fi.type==='signature'?'#d0e4ff':fi.type==='initials'?'#fff3cd':'#e2e3e5'"
          [style.color]="fi.type==='signature'?'#0056b3':fi.type==='initials'?'#856404':'#383d41'">
          {{ fi.type | uppercase }}
        </span>
        <label style="font-size:12px;font-weight:600;margin:0;">
          {{ fi.label }} <span style="color:#dc3545;">*</span>
        </label>
      </div>

      <!-- Text input -->
      <input class="input-filed-continers" type="text"
        [placeholder]="fi.type==='signature' ? 'e.g. John Smith'
                      : fi.type==='initials'  ? 'e.g. J.S'
                      : 'Enter ' + fi.label"
        [(ngModel)]="fi.value"
        maxlength="200"
        style="width:100%;font-size:13px;" />

      <!-- Font selector — shown for signature & initials -->
      <div *ngIf="fi.type==='signature' || fi.type==='initials'" class="mt-2">
        <label style="font-size:11px;color:#6c757d;">Style</label>
        <div class="d-flex gap-2 flex-wrap mt-1">
          <div *ngFor="let font of signFonts"
            (click)="fi.signFont = font.value"
            style="padding:5px 10px;border-radius:6px;cursor:pointer;border:1.5px solid;
                   font-size:14px;min-width:90px;text-align:center;transition:all 0.15s;"
            [style.font-family]="font.value"
            [style.border-color]="fi.signFont===font.value?'#0056b3':'#dee2e6'"
            [style.background]="fi.signFont===font.value?'#e8f0fe':'#fff'">
            {{ fi.value || 'Preview' }}
            <div style="font-size:9px;font-family:Arial;color:#6c757d;margin-top:2px;">{{ font.label }}</div>
          </div>
        </div>
      </div>

      <!-- Live preview for signature/initials -->
      <div *ngIf="(fi.type==='signature'||fi.type==='initials') && fi.value"
        style="background:#f8f9fa;border:1px dashed #dee2e6;border-radius:6px;
               padding:10px 14px;margin-top:8px;text-align:center;"
        [style.font-family]="fi.signFont">
        <span style="font-size:22px;color:#1a237e;">{{ fi.value }}</span>
      </div>
    </div>

    <!-- Date fields note -->
    <div style="background:#e8f4e8;border:1px solid #c3e6cb;border-radius:4px;
                padding:8px 12px;margin-top:12px;font-size:11px;color:#155724;">
      <i class="fa fa-calendar-check-o"></i>
      Date fields are auto-stamped with the current date &amp; time when you sign.
    </div>

    <div class="mt-2" style="font-size:11px;color:#6c757d;">
      <i class="fa fa-info-circle"></i>
      By clicking <strong>Sign Now</strong>, you confirm these are your legal digital signatures.
    </div>
  </div>

  <!-- Footer — Sign Now disabled until all fields filled -->
  <div style="padding:12px 16px;border-top:1px solid #dee2e6;
              display:flex;justify-content:flex-end;gap:8px;
              position:sticky;bottom:0;background:#fff;">
    <button mat-stroked-button class="cancelButton" (click)="showSignModal=false">
      <i class="fa fa-close"></i> Cancel
    </button>
    <div class="addIconContiner d-flex gap-2 align-items-center px-3"
      [style.opacity]="canSubmitSign ? '1' : '0.45'"
      [style.cursor]="canSubmitSign ? 'pointer' : 'not-allowed'"
      [title]="canSubmitSign ? 'Submit all fields' : 'Fill all required fields to enable'"
      (click)="canSubmitSign && submitSignature()">
      <i class="fa fa-check text-white"></i>
      <span class="reload_text text-white">
        {{ canSubmitSign ? 'Sign Now' : 'Fill All Fields...' }}
      </span>
    </div>
  </div>
</div>

<!-- Decline Modal -->
<div *ngIf="showDeclineModal"
  style="position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:1050;"
  (click)="showDeclineModal=false"></div>
<div *ngIf="showDeclineModal"
  style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);
         background:#fff;border-radius:8px;box-shadow:0 8px 32px rgba(0,0,0,0.2);
         width:420px;max-width:95vw;z-index:1051;">
  <div style="background:#f8f9fa;border-bottom:1px solid #dee2e6;padding:12px 16px;
              display:flex;align-items:center;justify-content:space-between;">
    <span style="font-size:14px;font-weight:700;color:#dc3545;">
      <i class="fa fa-times-circle"></i> Decline Signing
    </span>
    <i class="fa fa-times" style="cursor:pointer;color:#6c757d;" (click)="showDeclineModal=false"></i>
  </div>
  <div style="padding:16px;">
    <div class="mb-2"
      style="background:#fff3cd;border:1px solid #ffc107;border-radius:4px;
             padding:8px;font-size:12px;color:#856404;">
      <i class="fa fa-warning"></i> Declining will cancel the entire signing envelope for all parties.
    </div>
    <label style="font-size:12px;font-weight:600;">
      Reason for Declining <span style="color:#dc3545;">*</span>
    </label>
    <textarea class="textarea-filed-continers mt-1" rows="4"
      [(ngModel)]="declineComments"
      placeholder="Please provide the reason for declining..."
      style="width:100%;"></textarea>
  </div>
  <div style="padding:12px 16px;border-top:1px solid #dee2e6;
              display:flex;justify-content:flex-end;gap:8px;">
    <button mat-stroked-button class="cancelButton" (click)="showDeclineModal=false">
      <i class="fa fa-close"></i> Cancel
    </button>
    <button mat-stroked-button class="deleteButton" (click)="submitDecline()">
      <i class="fa fa-times"></i> Decline
    </button>
  </div>
</div>